import { QuestionCircleOutlined } from "@ant-design/icons";
import { Form, InputNumber, Switch, Tooltip } from "antd";

interface FeeProps {
	isPaymentAvailable?: boolean;
	primaryColor?: string;
}

export const Fee = ({
	isPaymentAvailable = true,
	primaryColor = "#99CA29",
}: FeeProps) => {
	return (
		<div className="flex items-center gap-4 h-8 mt-2">
			<div className="flex items-center gap-2">
				<span>有料イベント設定</span>
				<Tooltip
					title={
						<div>
							<div>有料イベント設定を行うには、</div>
							<div>決済代行会社との契約後が必要です。</div>
						</div>
					}
				>
					<QuestionCircleOutlined style={{ color: primaryColor }} />
				</Tooltip>
			</div>

			<Form.Item noStyle shouldUpdate={(prev, curr) => prev?.fee !== curr?.fee}>
				{({ getFieldValue, setFieldValue }) => {
					const feeValue = getFieldValue("fee");
					const isPaidEvent = feeValue !== 0 && feeValue !== null;

					return (
						<div className="flex items-center gap-2">
							<Switch
								checked={isPaidEvent}
								disabled={!isPaymentAvailable}
								onChange={(checked) => {
									if (checked) {
										setFieldValue("fee", undefined);
									} else {
										setFieldValue("fee", 0);
									}
								}}
							/>

							{isPaidEvent && (
								<div className="flex items-center gap-2">
									<Form.Item noStyle name="fee">
										<InputNumber
											size="middle"
											className="w-[150px]"
											min={1}
											placeholder="金額"
										/>
									</Form.Item>
									<span>円</span>
								</div>
							)}
						</div>
					);
				}}
			</Form.Item>
		</div>
	);
};
